import {
  shipmentTypeIconMapUK,
  shipmentTypeParentIconMapUK,
  themeColorMap,
  themeIconMap,
} from "@/configs/themeCategoryMap";
import {
  ParcelCategoryGe,
  ParcelCategoryUZ,
  ParcelCategoryUK,
  Theme,
} from "@/enums";

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

const getCategoryColors = (
  category: ParcelCategoryUZ | ParcelCategoryGe | ParcelCategoryUK,
  theme: Theme,
  type: "bg" | "fill",
) => {
  const colorGroups = themeColorMap[theme];
  const result = Object.entries(colorGroups).reduce(
    (acc, [group, values]) => {
      acc[`${type}-custom${capitalize(group)}-${type}`] =
        values.includes(category);
      return acc;
    },
    {} as Record<string, boolean>,
  );
  if (!Object.values(result).some(Boolean)) {
    result[`${type}-customBlue-${type}`] = true;
  }
  return result;
};

const getCategoryWrapperColors = (
  category: ParcelCategoryUZ | ParcelCategoryGe | ParcelCategoryUK,
  theme: Theme,
) => getCategoryColors(category, theme, "bg");

const getCategoryIconColors = (
  category: ParcelCategoryUZ | ParcelCategoryGe | ParcelCategoryUK,
  theme: Theme,
) => getCategoryColors(category, theme, "fill");

export const getCategoryDetails = (
  category: ParcelCategoryUZ | ParcelCategoryGe | ParcelCategoryUK,
  theme: Theme,
  shipmentTypeParentId?: number,
) => {
  const effectiveCategory =
    theme === Theme.UK && shipmentTypeParentId != null
      ? (shipmentTypeParentId as ParcelCategoryUK)
      : category;
  return {
    wrapperStyles: getCategoryWrapperColors(effectiveCategory, theme),
    iconStyles: getCategoryIconColors(effectiveCategory, theme),
    icons:
      theme === Theme.UK && shipmentTypeParentId != null
        ? shipmentTypeParentIconMapUK
        : theme === Theme.UK
          ? shipmentTypeIconMapUK
          : themeIconMap[theme],
  };
};
